/**
 * Record Flow for managers: /portal/record-flow.
 *
 * The same page as the admin console's, reading /record-flow instead of
 * /admin/record-flow. The server decides who may open it (RECORD_FLOW_VIEW and
 * PHI access); this page only points the views at the other base and gives the
 * page the workspace bar the portal workspaces carry.
 */
import React, { useLayoutEffect } from 'react';
import WorkspaceMenu from '../../../components/WorkspaceMenu';
import RecordFlow from './RecordFlow';
import { PORTAL_FLOW_BASE, setFlowBase } from './flowApi';
import { WorkspaceLayout, SidebarTrigger, type SidebarGroup } from '../../../components/workspaceSidebar';
import { Workflow } from 'lucide-react';

// RecordFlow keeps its own tabs; the sidebar names the workspace and holds its one door.
const GROUPS: SidebarGroup[] = [
  { key: 'record-flow', label: 'Record Flow', items: [{ key: 'overview', label: 'Overview', icon: Workflow, href: '/portal/record-flow', active: true }] },
];

export default function RecordFlowPortal() {
  // Layout effects of the whole tree run before any passive (load) effect, so no view reads the admin base first.
  useLayoutEffect(() => {
    const previous = setFlowBase(PORTAL_FLOW_BASE);
    return () => { setFlowBase(previous); };
  }, []);
  return (
    <div>
      <WorkspaceMenu current="RECORD_FLOW" />
      <WorkspaceLayout workspace="RECORD_FLOW" navLabel="Record Flow views" groups={GROUPS}>
        <main className="mx-auto w-full max-w-[1400px] px-4 py-4">
          <div className="mb-2"><SidebarTrigger /></div>
          <RecordFlow />
        </main>
      </WorkspaceLayout>
    </div>
  );
}
